import api from '@/api/config';

const state = {
	connections: [],
	loading: false,
	error: null
};

const mutations = {
	setConnections(state, connections) {
		state.connections = connections;
	},
	setLoading(state, loading) {
		state.loading = loading;
	},
	setError(state, error) {
		state.error = error;
	}
};

const actions = {
	async loadConnections({ commit }, integrationId) {
		commit('setLoading', true);
		commit('setError', null);

		try {
			const data = await api.getVirtualConnections();
			// Filter connections by integrationId
			const filteredConnections = data.filter(connection =>
				connection.integrationId === integrationId
			);
			// Sort connections - active first, then pending
			const sortedConnections = filteredConnections.sort((a, b) => {
				const aStatus = (a.pendingCode && !a.childOrganizationId) ? 'pending' : 'active';
				const bStatus = (b.pendingCode && !b.childOrganizationId) ? 'pending' : 'active';
				if (aStatus === 'active' && bStatus === 'pending') return -1;
				if (aStatus === 'pending' && bStatus === 'active') return 1;
				return 0;
			});
			commit('setConnections', sortedConnections);
		} catch (error) {
			commit('setError', error.message || 'Failed to load virtual connections');
			commit('setConnections', []);
		} finally {
			commit('setLoading', false);
		}
	},

	async createConnection({ commit }, integrationId) {
		commit('setError', null);

		try {
			await api.createVirtualConnection(integrationId);
		} catch (error) {
			commit('setError', error.message || 'Failed to create virtual connection');
			throw error;
		}
	},

	async deleteConnection({ commit }, guid) {
		commit('setError', null);

		try {
			await api.deleteVirtualConnection(guid);
		} catch (error) {
			commit('setError', error.message || 'Failed to delete virtual connection');
			throw error;
		}
	},

	async updateConnection({ commit }, { guid, settings }) {
		commit('setError', null);

		try {
			await api.updateVirtualConnection(guid, settings);
		} catch (error) {
			commit('setError', error.message || 'Failed to update virtual connection');
			throw error;
		}
	}
};

const getters = {
	getConnectionsByIntegration: (state) => (integrationId) => {
		return state.connections.filter(connection =>
			connection.integrationId === integrationId
		);
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};